import { InfoCircleOutlined } from "@ant-design/icons";
import { Flex, Image, List, Tooltip } from "antd";
import dayjs from "dayjs";
import { FC, useEffect, useRef, useState } from "react";
import { displayDateFormat } from "tm-shared/constants";
import { formatBytes } from "tm-shared/utils";

import { StyledTag } from "@/components/Modals/UploadRetryModal/Styled";
import { PrimaryText } from "@/components/Typography/Styled";
import { useInViewObserver } from "@/hooks/useInViewObserver";
import {
    photoStorage,
    StoredPhoto,
    StoredPhotoMeta,
} from "@/Services/PhotoStorage";

interface PhotoListItemProps {
    photo: StoredPhotoMeta;
    setActivePhoto: (photo: StoredPhoto) => void;
    isLast: boolean;
    onInView: () => void;
}

export const PhotoListItem: FC<PhotoListItemProps> = ({
    photo,
    setActivePhoto,
    isLast,
    onInView,
}) => {
    const {
        id,
        name,
        type,
        size,
        lastError,
        uploadAttempts,
        lastUploadAt,
        createdAt,
    } = photo;

    const [base64, setBase64] = useState("");

    const dateText = dayjs(createdAt).format(displayDateFormat.dateTime);

    const lastTryText = lastUploadAt
        ? dayjs(lastUploadAt).format(displayDateFormat.dateTime)
        : "---";

    useEffect(() => {
        photoStorage
            .getPhoto(id)
            .then((result) => setBase64(result))
            .catch((error) => console.error(error));
    }, [id]);

    const cardRef = useRef(null);

    useInViewObserver(cardRef, () => {
        if (isLast) onInView();
    });

    return (
        <List.Item ref={cardRef}>
            <List.Item.Meta
                avatar={
                    <Image
                        width={72}
                        height={72}
                        src={base64}
                        style={{
                            objectFit: "cover",
                            borderRadius: 10,
                            cursor: "pointer",
                        }}
                        onClick={() => setActivePhoto({ ...photo, base64 })}
                    />
                }
                title={
                    <Flex vertical gap={4}>
                        <PrimaryText strong ellipsis>
                            {name}
                        </PrimaryText>

                        <Flex wrap gap={6}>
                            <StyledTag>{type}</StyledTag>
                            <StyledTag>{formatBytes(size)}</StyledTag>

                            <Tooltip title={lastError}>
                                <StyledTag color="orange">
                                    спроб: {uploadAttempts}{" "}
                                    <InfoCircleOutlined />
                                </StyledTag>
                            </Tooltip>
                        </Flex>
                    </Flex>
                }
                description={
                    <Flex vertical gap={2}>
                        <PrimaryText type="secondary">
                            Дата створення: {dateText}
                        </PrimaryText>
                        <PrimaryText type="secondary">
                            Остання спроба: {lastTryText}
                        </PrimaryText>
                    </Flex>
                }
            />
        </List.Item>
    );
};
